import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MyLog } from '@common/common';
import {
  MatDialog,
} from '@angular/material/dialog';

import { TimePickerDialog, convTo2Digits } from './time-picker-dialog';

let pickerId = 1;


@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',

})
export class TimePickerComponent implements OnInit {

  id!: string;

  @Input() label = '';

  _valueTxt = '';

  public _value: any;
  @Input() set value(value: any) {
    this._value = value;
    //console.log("VAL:", this._value);
    this.updateText();
  }
  updateText() {
    if (this._value instanceof Date) {
      this._valueTxt = convTo2Digits(this._value.getHours(), 23, 0) + ":" +
        convTo2Digits(this._value.getMinutes(), 59, 0);
    }
  }

  @Output() valueChange = new EventEmitter();

  public _required = false;
  @Input() set required(req: boolean) {
    this._required = req;
  }

  constructor(public dialog: MatDialog) {
    pickerId++;
    this.id = 'time-picker-' + pickerId;
  }

  /*
  public _ov = false;
  @Input() set ov(req: boolean) {
    this._ov = req;
  }
  */

  ngOnInit(): void {

  }

  onDateChange($event: any) {
    this._value = $event;
    this.updateText();
    this.valueChange.emit($event);
  }

  timeChangeHandler($event: any) {
    this.valueChange.emit($event);
  }

  invalidInputHandler() {
    MyLog.log('INvalid:');
  }

  showDialog() {
    const dialogRef = this.dialog.open(TimePickerDialog, {
      data: {
        okLabel: "OK",
        cancelLabel: "Abbrechen",
        time: {
          h: 20,
          m: 40
        },
        width: 320,
        version: 2,
        value: this._value
      },//{name: this.name(), animal: this.animal()},
      width: "400px"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this._value = result;
        this.updateText();
        this.valueChange.emit(result);
      }
    });
  }
}
